import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import type React from 'react'

type Props = React.PropsWithChildren<unknown>

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
})

export function getContext() {
  return { queryClient }
}

export function Provider({ children }: Props) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
